import * as React from 'react';
import * as mui from '@mui/material';
import * as icons from '@mui/icons-material';

import TextField from 'components/General/TextField';
import CharacterDialogButton from 'components/General/CharacterDialogButton';
import { usePreviewPageContext } from 'context/PreviewPageContext';

export default function Step2() {
	const {
		character1,
		name2,
		setName2,
		name3,
		setName3,
		character2,
		setCharacter2,
		character3,
		setCharacter3,
		handleContinue,
		handleBack,
	} = usePreviewPageContext();

	React.useEffect(() => {
		window.scroll({ top: 0, left: 0 });
	}, []);

	return (
		<>
			<mui.Typography variant='h5' color='white' sx={{ mb: 3 }}>
				1. Indica il secondo protagonista
			</mui.Typography>

			<TextField
				value={name2}
				setValue={setName2}
				placeholder='Nome secondo protagonista'
				startIcon={
					<img
						src={
							character2
								? `https://storage.googleapis.com/faboola_wordpress_static/img/characters/${character2.toUpperCase()}.png`
								: '/wp-content/uploads/2021/11/testavuota.jpg'
						}
						loading='lazy'
						alt='second protagonist'
						width={35}
						height={35}
					/>
				}
				errorMessage='Il nome inserito è troppo lungo'
				StackProps={{ sx: { mb: 4 } }}
			/>

			<mui.Typography variant='h5' color='white' sx={{ mb: 3 }}>
				2. {character2 === '' ? 'Scegli il suo aspetto' : 'Cambia il suo aspetto'}
			</mui.Typography>

			<mui.Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={3} sx={{ mb: 4 }}>
				<CharacterDialogButton
					index={2}
					isMale={false}
					selectedCharacter1={character1}
					selectedCharacter={character2}
					setSelectedCharacter={setCharacter2}
				/>

				<CharacterDialogButton
					index={2}
					isMale={true}
					selectedCharacter1={character1}
					selectedCharacter={character2}
					setSelectedCharacter={setCharacter2}
				/>
			</mui.Stack>

			<mui.Typography variant='h5' color='white' sx={{ mb: 3 }}>
				3. Indica il terzo protagonista
			</mui.Typography>

			<TextField
				value={name3}
				setValue={setName3}
				placeholder='Nome terzo protagonista'
				startIcon={
					<img
						src={
							character3
								? `https://storage.googleapis.com/faboola_wordpress_static/img/characters/${character3.toUpperCase()}.png`
								: '/wp-content/uploads/2021/11/testavuota.jpg'
						}
						loading='lazy'
						alt='third protagonist'
						width={35}
						height={35}
					/>
				}
				errorMessage="Inserisci un nome con meno di 20 caratteri e scegli l'aspetto"
				StackProps={{ sx: { mb: 4 } }}
			/>

			<mui.Typography variant='h5' color='white' sx={{ mb: 3 }}>
				4. {character3 === '' ? 'Scegli il suo aspetto' : 'Cambia il suo aspetto'}
			</mui.Typography>

			<mui.Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={3} sx={{ mb: 4 }}>
				<CharacterDialogButton
					index={3}
					isMale={false}
					selectedCharacter1={character1}
					selectedCharacter={character3}
					setSelectedCharacter={setCharacter3}
				/>

				<CharacterDialogButton
					index={3}
					isMale={true}
					selectedCharacter1={character1}
					selectedCharacter={character3}
					setSelectedCharacter={setCharacter3}
				/>
			</mui.Stack>

			<mui.Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
				<mui.Button onClick={handleBack} sx={{ ml: 1 }}>
					Indietro
				</mui.Button>

				<mui.Button variant='contained' onClick={handleContinue} endIcon={<icons.ArrowForwardOutlined />} sx={{ ml: 1 }}>
					Continua
				</mui.Button>
			</mui.Box>
		</>
	);
}
